import '@/api/polyfill.object'
import 'whatwg-fetch'

import Vue from 'vue'

import './plugins/vuelidate'
import './plugins/vuetify'
import './plugins/fetch'
import './plugins/gmap'

import './api/network.watcher'
import './api/basket.watcher'
import './api/profile.watcher'

import App from './App.vue'
import router from './router/'
import store from './store/'

import './registerServiceWorker'

import 'roboto-fontface/css/roboto/roboto-fontface.css'
//не забыть убрать из index.html, а здесь включить
//import 'material-design-icons/iconfont/material-icons.css'
import './scss/main.scss'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

//заставка из index.html видна, пока не открыта первая страница: до этого роутер ждёт проверку авторизации
function hideSplash() {
  const splash = document.getElementById('splash')
  if (!splash) return
  splash.classList.add('splash--hidden')
  setTimeout(() => splash.parentNode && splash.parentNode.removeChild(splash), 300)
}
router.onReady(hideSplash, hideSplash)
